/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ProfileImage/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import Avatar from 'DesignSystem/Avatar/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function ProfileImage({
  children,
  viewPath = "/DesignSystem/TimeGrid/FullCalendarTimegrid/Appointment/InfoDialog/Content/Content/ExternalProfessionals/Content/ExternalProfessional/ProfileImage",
  presignedUrl
  
}) {
let externalProfessionalOtherPersonValueData = fromData.useDataFormat({ viewPath,
context: 'external_professional',
path: 'other.person',
format: fromFormat.initials,
})
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
  return (<React.Fragment
>
<Avatar
  viewPath={`${viewPath}/Avatar`}
 profile_url={presignedUrl}
 data="external_professional.other.person"
 format="/Data/format.js initials"
 initials={externalProfessionalOtherPersonValueData}
 backgroundColor={dtColorsNeutral200}
/>
{children}
</React.Fragment>)
}